import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Container, Video, ContainerMessage } from './style'
import { checkGeolocation } from '../../helpers/geo'
import { SubContainerButton } from '../Configuration/style'
import Button from '../../components/Button/Button'


class ReportUser extends PureComponent { 
 state = {
  loadingGeo: true,
  geoOk: false,
  message: '',
  errorCode: 1,
  sucesso: false,
  from: false
 }

  clickTest () {
   
    
    switch(this.state.errorCode) {
      case '1':
         if(navigator.onLine){
          this.setState({sucesso: true, message: ''})
          setTimeout(function(){  
            if(this.state.from === 'start'){
              window.location.href= '/home'
            }else{
              window.history.back(); 
            }
            
          }, 1800);
         } else {
          this.setState({message: 'Você precisa estar conectado a uma rede para prosseguir.'});
         }
        break;
      case '2':
        checkGeolocation().then((result) => {
          if(result){
            this.setState({sucesso: true, errorCode: true, message: ''})
            setTimeout(() => {  
              if(this.state.from === 'start'){
                window.location.href= '/home'
              }else{
                window.history.back(); 
              }
            }, 1800);
            
          }else{
            this.setState({message: 'Seu dispositivo não está com o GPS habilitado ou você clicou em bloquear quando o acesso foi solicitado. Por favor habilite o GPS ou desbloqueie nas configurações do Google Chrome.'});
          }
        
        })
        break
        default:
          break
     
       
    }
   
  }
  componentDidMount () {   
    /*checkGeolocation().then((result) => {
      this.setState({geoOk: result, loadingGeo: false})        
      if(result){
        setTimeout(() => {
          //window.location.href = '/home'
        }, 3000)
      }
    })*/
    this.getParameters()
 }

 getParameters = () => {
  let search = window.location.search;
  let params = new URLSearchParams(search);
  //let message = params.get('message')
  let errorCode = params.get('errorCode')
  let from = params.get('from')
  if(errorCode === 1){
    this.setState({message: 'Você precisa estar conectado a uma rede para prosseguir.'});
  }
  if(errorCode === 2){
    this.setState({message: 'Seu dispositivo não está com o GPS habilitado ou você clicou em bloquear quando o acesso foi solicitado. Por favor habilite o GPS ou desbloqueie nas configurações do Google Chrome.'});
  }
  this.setState({errorCode, from})
 }
 
 
 render() {
    
   return (
    <Container>
      {
        this.state.sucesso === false  &&
        <Video autoPlay loop muted>
          <source src={ require('../../assets/videos/sucesso.mp4') } type='video/mp4' />  
        </Video> 
      }

      {
        this.state.sucesso === true &&
        <Video autoPlay loop muted>
          <source src={ require('../../assets/videos/bloqueio.mp4') } type='video/mp4' />  
        </Video> 
      }
      <ContainerMessage>
       <span>{this.state.message}</span>
      </ContainerMessage>
      {
        this.state.sucesso === false  &&
      <SubContainerButton>
        <Button backgroundColor='#40bbca' onClick={() => { this.clickTest() }}>Tentar novamente</Button>  
      </SubContainerButton>
      }

      
    </Container>
   )
 }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default connect(
  mapStateToProps, mapDispatchToProps
)(ReportUser)



